// Fichier préparé à la demande (PDF, ZIP) : l'élément reste en attente
// (aria-busy, désactivé, `label` affiché dans `labelElement`, l'élément
// lui-même par défaut) jusqu'à ce que le serveur pose le cookie
// `download_ready` avec le jeton envoyé (ApplicationController#signal_download),
// ou 2 minutes au plus ; `onDone` est appelé à la fin de l'attente. Renvoie
// le jeton à joindre à la requête (download_token).
export function waitForDownload(element, label, onDone, labelElement = element) {
    const token = Math.random().toString(36).slice(2, 12);
    const text = labelElement.textContent;
    element.setAttribute('aria-disabled', 'true');
    element.setAttribute('aria-busy', 'true');
    element.classList.add('pointer-events-none', 'opacity-60');
    if (label) labelElement.textContent = label;
    const started = Date.now();
    const timer = setInterval(() => {
        const ready = document.cookie.split('; ').includes(`download_ready=${token}`);
        if (!ready && Date.now() - started < 120000) return;
        clearInterval(timer);
        element.removeAttribute('aria-disabled');
        element.removeAttribute('aria-busy');
        element.classList.remove('pointer-events-none', 'opacity-60');
        if (label) labelElement.textContent = text;
        document.cookie = 'download_ready=; path=/; max-age=0';
        onDone?.();
    }, 300);
    return token;
}
